import PropTypes from 'prop-types';
import { forwardRef, lazy, Suspense } from 'react';

const Switch = lazy(() => import('react-switch'));

const ReactSwitch = forwardRef(
    (
        {
            isOn,
            handleToggle,
            id,
            disabled,
            onColor = '#1d81d9',
            offColor = '#abb3b9',
            className = '',
            height = 20,
            handleDiameter = 16,
            width = 34,
        },
        ref
    ) => {
        return (
            <Suspense>
                <div className={`relative flex max-h-7 items-center`}>
                    <Switch
                        className={className}
                        ref={ref}
                        onChange={handleToggle}
                        checked={!!isOn}
                        disabled={disabled}
                        onColor={onColor}
                        offColor={offColor}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        height={height}
                        handleDiameter={handleDiameter}
                        width={width}
                        id={id.toString()}
                    />
                </div>
            </Suspense>
        );
    }
);

ReactSwitch.displayName = 'ReactSwitch';

ReactSwitch.propTypes = {
    isOn: PropTypes.bool,
    handleToggle: PropTypes.func.isRequired,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    disabled: PropTypes.bool,
    onColor: PropTypes.string,
    offColor: PropTypes.string,
    className: PropTypes.string,
    height: PropTypes.number,
    handleDiameter: PropTypes.number,
    width: PropTypes.number,
};

export default ReactSwitch;
